import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  CardImg,
  Col,
  Offcanvas,
  OffcanvasBody,
  Row,
  Spinner,
} from "reactstrap";

import toast from "react-hot-toast";
import restro from "../../../../assets/orderingSystem/restrologo.png";

import CancelOrder from "./component/CancelOrder";
import { deleteOrderItems } from "../../../../slices/Order/orderSlice";
import { useDispatch } from "react-redux";

import RestroOrderService from "../../../../services/RestroOrder/RestroOrderService";
import FoodCourt from "../Table/page/FoodCourt";
import NoteModal from "./component/NoteModal";

const OrderSummaryModal = ({
  orderData,

  isQuantityChanged,

  sectionData,
  setSelectedSection,
  selectedSection,
  isOpen,
  toggle,
  fetchOrder,

  handlePlaceOrder,
  setItemCounts,
  itemCounts,

  handleRefresh,
  isRefreshing,
  fetchSection,
  selectedCourt,
  setSelectedCourt,

  fetchTable,
  productExtrasMap,
  setProductExtrasMap,
  setSelectedNotes,
  selectedNotes,
}) => {
  console.log("🚀 ~ OrderSummaryModal ~ orderData:", orderData);
  const [selectedCustomer, setSelectedCustomer] = useState(
    JSON.parse(localStorage.getItem("selectedCustomer")) || null
  );
  const [activeNoteProduct, setActiveNoteProduct] = useState(null);

  const [isTableOpen, setIsTableOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isRight, setIsRight] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  console.log("🚀 ~ OrderSummaryModal ~ selectedItems:", selectedItems);
  const [deleteModal, setDeleteModal] = useState(false);
  const [discountPercent, setDiscountPercent] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [lastUpdated, setLastUpdated] = useState(null);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const toggleTableModal = () => setIsTableOpen(!isTableOpen);
  const dispatch = useDispatch();
  const [isNoteOpen, setIsNoteOpen] = useState(false);
  const toggleNote = (product) => {
    setActiveNoteProduct(product); // set the current product
    setIsNoteOpen((prev) => !prev);
  };
  const handleCheckboxChange = (itemKey, item) => {
    setSelectedItems((prev) => {
      // Check if the item is already selected
      const exists = prev.find((i) => i.itemKey === itemKey);
      if (exists) {
        // Remove it (unselect)
        return prev.filter((i) => i.itemKey !== itemKey);
      } else {
        // Add it
        return [...prev, { itemKey, ...item }];
      }
    });
  };

  const [remarks, setRemarks] = useState();
  const [touched, setTouched] = useState();
  const isInvalid = touched && !remarks?.trim();

  const handleDeleteItem = async () => {
    if (!selectedItems.length) {
      toast.error("No items selected for deletion.");
      return;
    }

    if (!remarks?.trim()) {
      setTouched(true);
      return;
    }

    try {
      const tableId = selectedCourt?.TableKey;

      // ---------------------------------------------------------------
      // 1. Separate local vs placed items
      // ---------------------------------------------------------------
      const localItems = [];
      const placedItems = [];

      selectedItems.forEach((item, index) => {
        if (item.isLocalItem) {
          localItems.push({ orderIndex: 0, itemIndex: index });
        } else {
          placedItems.push({
            CanceledBy: "superuser",
            OrderBy: "superuser",
            Item: item?.productName || "",
            Quantity: String(item?.finalQuantity ?? item?.quantity ?? 0),
            Reason: remarks?.trim() || "No reason provided",
            Responsible: "Waiter",
            tableId: 0,
            ItemIndex: String(item?.OrderIndex),
            ItemID: String(item?.productId),
            orderMasterID: selectedCourt?.OrderMasterID ?? 0,
          });
        }
      });

      // ---------------------------------------------------------------
      // 2. Delete local items in Redux
      // ---------------------------------------------------------------
      if (localItems.length) {
        dispatch(deleteOrderItems({ tableId, itemIndexes: localItems }));
      }

      // ---------------------------------------------------------------
      // 3. Cancel placed items via the service (old flow)
      // ---------------------------------------------------------------
      if (placedItems.length) {
        await RestroOrderService.cancelOrderByItems({
          canceledItems: placedItems,
        });

        // Remove from Redux after API success
        dispatch(
          deleteOrderItems({
            tableId,
            itemIndexes: selectedItems
              .filter((i) => !i.isLocalItem)
              .map((_, idx) => ({ orderIndex: 0, itemIndex: idx })),
          })
        );
      }

      // ---------------------------------------------------------------
      // 4. UPDATED – Send API only with remaining placed items
      // ---------------------------------------------------------------
      if (placedItems.length) {
        const userData = JSON.parse(localStorage.getItem("user") || "{}");
        const userName = userData.userName || userData.username || "superuser";

        // 4A. Filter out cancelled placed items → keep only remaining placed items
        const remainingPlacedItems = orderData[selectedCourt?.TableKey]?.items
          ?.filter(
            (item) =>
              !selectedItems.some(
                (s) =>
                  s.productId === item.productId &&
                  s.OrderIndex === item.OrderIndex
              )
          )
          ?.filter((item) => !item.isLocalItem);

        // 4B. Map to orderDetails format
        const updatedOrderDetails = remainingPlacedItems.map((item) => ({
          ItemId: item.productId,
          Quantity: Number(item.finalQuantity ?? item.quantity ?? 0),
          IsCombo: item.children?.length > 0 || false,
          Rate: Number(item.productPrice || 0),
          Note: item.remarks || "",
          SeatNo: 1,
          Amount: Number(item.productPrice * (item.finalQuantity ?? 1)),
          Waiter: userName,
          Index: item.OrderIndex,
        }));

        const payload = {
          orderMasterInfo: {
            Address: "",
            ArchivedBy: "superuser",
            UserName: "superuser",
            BillNo: "",
            BillPaid: 0,
            phoneNo: selectedCustomer?.TelMobile || "",
            names: selectedCustomer?.Fname || "",
            orderDetailsList: updatedOrderDetails,
            TableId: 0,
            Remarks: remarks?.trim() || "Updated after item removal",
            OrderTypeID: 9,
            GuestNo: 1,
            IsSplit: false,
            IsCancelled: false,
            NetAmount: 0,
            membershipId: -1,
            TableKey: selectedCourt?.TableKey || "",
            OrderMasterId: selectedCourt?.OrderMasterID ?? 0,
          },
          orderExtraItem: [],
          foodCourtOrder: false,
        };

        const response = await RestroOrderService.order(payload);
        if (!response?.d) {
          throw new Error("Order update failed");
        }
      }

      // ---------------------------------------------------------------
      // 5. Refresh UI
      // ---------------------------------------------------------------
      fetchOrder();
      fetchSection();
      setSelectedItems([]);
      setRemarks("");
      setTouched(false);
      toast.success("Selected items removed from order.");
      toggleDeleteModal();
    } catch (error) {
      console.error("Error deleting items:", error);
      toast.error("Failed to remove items.");
    }
  };

  const filteredOrders = useMemo(() => {
    const ordersArray = Object.values(orderData);
    return selectedCourt
      ? ordersArray.filter((order) => order.TableKey === selectedCourt.TableKey)
      : ordersArray;
  }, [orderData, selectedCourt]);
  // ----- Calculate Totals -----

  const calculateTotals = useMemo(() => {
    let subTotal = 0;

    const orders = Array.isArray(filteredOrders)
      ? filteredOrders
      : Object.values(filteredOrders);

    orders.forEach((order) => {
      const items = order.items || [];

      items.forEach((item) => {
        const itemKey = item.OrderIndex; // Use same key as updateQuantity

        const count =
          itemCounts[itemKey] != null && itemCounts[itemKey] !== ""
            ? Number(itemCounts[itemKey])
            : Number(item.finalQuantity ?? item.quantity ?? 0);

        let itemPrice = 0;
        if (item.productPrice != null) itemPrice = Number(item.productPrice);
        else if (item.Rate != null) itemPrice = Number(item.Rate);
        else if (item.SRate != null) itemPrice = Number(item.SRate);
        else if (item.Amount != null)
          itemPrice = Number(item.Amount) / (item.quantity || 1);
        else if (Array.isArray(item.attributes) && item.attributes.length > 0) {
          itemPrice = item.attributes.reduce(
            (sum, attr) => sum + (parseFloat(attr.value) || 0),
            0
          );
        }

        subTotal += itemPrice * count;
      });
    });

    let discount = 0;
    let effectiveDiscountPercent = 0;

    discount = Math.min(discount, subTotal);
    const total = Math.max(0, subTotal - discount);

    return { subTotal, discount, total, effectiveDiscountPercent };
  }, [
    filteredOrders,
    itemCounts,

    discountPercent,
    discountAmount,
    lastUpdated,
    selectedCustomer,
  ]);

  // ----- Sync Discount for Customer Type -----
  useEffect(() => {
    if (lastUpdated) return;

    const percent =
      parseFloat(selectedCustomer?.customerTypeDiscount ?? 0) || 0;
    const amount = (percent / 100) * (calculateTotals.subTotal ?? 0);

    if ((discountPercent ?? "") !== percent.toFixed(2)) {
      setDiscountPercent(percent.toFixed(2));
    }

    if ((discountAmount ?? "") !== amount.toFixed(2)) {
      setDiscountAmount(amount.toFixed(2));
    }

    if (!selectedCustomer) {
      setDiscountPercent("");
      setDiscountAmount("");
    }
  }, [selectedCustomer, calculateTotals.subTotal, lastUpdated]);

  // ----- Sync Percent when Manual Amount is Entered -----
  useEffect(() => {
    if (!discountAmount || lastUpdated !== "amount") return;

    const amount = parseFloat(discountAmount);
    const subTotal = calculateTotals.subTotal ?? 0;

    if (subTotal > 0 && !isNaN(amount) && amount >= 0 && amount <= subTotal) {
      const percent = ((amount / subTotal) * 100).toFixed(2);
      if (percent !== discountPercent) setDiscountPercent(percent);
    }
  }, [discountAmount, calculateTotals.subTotal, lastUpdated]);

  useEffect(() => {
    if (selectedCourt?.TableKey) {
      setIsTableOpen(false);
    }
  }, []);

  useEffect(() => {
    setSelectedItems([]);
  }, [selectedCourt?.TableKey]);
  useEffect(() => {
    setSelectedItems([]);
    setRemarks("");
    setTouched(false);
  }, [selectedCourt?.TableKey]);

  useEffect(() => {
    if (!isRight) {
      setDiscountAmount("");
      setDiscountPercent("");
      // setSelected(null); // Reset local selected state
      setLastUpdated(null); // Reset last updated timestamp
    }
  }, [
    isRight,

    setDiscountAmount,
    setDiscountPercent,
    setLastUpdated,
    // setSelected,
  ]);
  const currentOrder = selectedCourt?.TableKey
    ? orderData[selectedCourt.TableKey]
    : null;
  console.log("🚀 ~ OrderSummaryModal ~ currentOrder:", currentOrder);
  const hasOrderId = currentOrder?.TableKey; // Order has been placed
  const isNewItem = currentOrder?.isNewItem;
  const getOrderButtonState = () => {
    if (
      !(selectedCourt || selectedCourt) ||
      !orderData[selectedCourt?.TableKey] ||
      !orderData[selectedCourt?.TableKey].items
    ) {
      return {
        text: "Place Order",
        disabled: true,
        variant: "success",
        action: handlePlaceOrder,
      };
    }

    if (!hasOrderId) {
      return {
        text: "Place Order",
        disabled: false,
        variant: "success",
        action: handlePlaceOrder, // Add this
      };
    }

    if (hasOrderId && (isNewItem || isQuantityChanged)) {
      return {
        text: "Update Order",
        disabled: false,
        variant: "warning",
        action: handlePlaceOrder, // Add this
      };
    }

    return {
      text: "Already Placed",
      disabled: false,
      variant: "secondary",
      action: handlePlaceOrder, // Optional: empty function for consistency, but not needed since disabled
    };
  };

  const orderButtonState = getOrderButtonState();

  const handleCardClick = (itemKey, item) => {
    handleCheckboxChange(itemKey, item);
  };

  const updateQuantity = (OrderIndex, newQty) => {
    setItemCounts((prev) => ({
      ...prev,
      [OrderIndex]: Math.max(0, Math.min(100, newQty)), // clamp between 1-100
    }));
  };
  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      backdropClassName="bg-dark bg-opacity-50"
      className="shadow-lg animate__animated animate__slideInRight bg-white rounded-start"
      id="offcanvasRight"
    >
      <div className="d-flex justify-content-start align-items-center p-3 shadow-sm rounded-top">
        <button className="btn btn-sm btn-light" onClick={toggle}>
          <i className="bx bx-chevron-left"></i>
        </button>
        <div className="text-center w-100">
          <h5 className="mb-0 ms-2">Order Summary</h5>
        </div>

        <div
          className="d-flex align-items-center gap-2 cursor-pointer"
          onClick={!isRefreshing ? handleRefresh : null}
        >
          <i
            className={`ri-refresh-line fs-4 ${
              isRefreshing ? "refresh-rotate" : ""
            }`}
            title="Refresh"
            style={{ opacity: isRefreshing ? 0.5 : 1 }}
          ></i>

          {isRefreshing && <span style={{ fontSize: "14px" }}></span>}
        </div>
      </div>
      <OffcanvasBody className="p-0">
        <div
          className="d-flex flex-column overflow-hidden rounded-4"
          style={{ height: "95vh" }}
        >
          <div className="border-0 shadow-sm mb-0 flex-shrink-0 p-2">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div
                className="d-flex align-items-center gap-2 cursor-pointer"
                onClick={toggleTableModal}
              >
                <i
                  className="ri-restaurant-line fs-4 text-success"
                  title="Select Food Court"
                ></i>
                <div>
                  <div className="text-muted small">Food Court</div>
                  <h6 className="mb-0 fw-bold">
                    {selectedCourt?.TableKey || "Select Court"}
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div
            className="px-lg-4 px-3 py-2 gx-3 gy-4 flex-grow-1 overflow-auto bg-light"
            style={{ minHeight: 0 }}
          >
            {loading ? (
              <Spinner />
            ) : error ? (
              <div className="text-center text-danger">{error}</div>
            ) : selectedCourt && !orderData[selectedCourt.TableKey] ? (
              <div className="text-center text-muted">
                No orders found for table {selectedCourt.TableKey}.
              </div>
            ) : orderData?.length === 0 ? (
              <div className="text-center text-muted">
                No items for the selected table.
              </div>
            ) : (
              <>
                {filteredOrders
                  .flatMap((order) => order.items || [])
                  .map((item, itemIndex) => {
                    const productId = item.productId;
                    const OrderIndex = item?.OrderIndex;
                    console.log("🚀 ~ OrderSummaryModal ~ item:", item);
                    const isSelected = selectedItems.some(
                      (i) => i.OrderIndex === OrderIndex
                    );
                    const count = itemCounts[OrderIndex] ?? item.quantity ?? 1;
                    console.log("counted", count);
                    return (
                      <div
                        key={OrderIndex}
                        className={`rounded-3 shadow-sm px-2 py-2 mb-2 border border-light-subtle transition-all ${
                          isSelected
                            ? "bg-danger-subtle border-danger"
                            : "bg-white"
                        } ${
                          item?.isLocalItem ? "bg-warning-subtle" : "bg-white"
                        }`}
                        onClick={() => handleCardClick(OrderIndex, item)}
                        style={{ cursor: "pointer", fontSize: "13px" }}
                      >
                        <Row className="align-items-center gx-2">
                          <Col xs={2}>
                            <CardImg
                              src={restro}
                              alt={item.productName}
                              className="img-fluid rounded-2"
                              style={{
                                objectFit: "contain",
                                height: "45px",
                                width: "100%",
                              }}
                            />
                          </Col>

                          <Col xs={10}>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <strong
                                className="text-truncate"
                                style={{ maxWidth: "75%" }}
                              >
                                {item?.productName}
                              </strong>

                              {item?.complimentaryQuantity > 0 ? (
                                <span className="me-3">
                                  <strong>🎁</strong>{" "}
                                  {item.complimentaryQuantity}
                                </span>
                              ) : (
                                <>
                                  <span className="fs-14 fw-semibold">
                                    {item?.productPrice != null
                                      ? `Rs. ${(
                                          item?.productPrice * count
                                        ).toFixed(2)}`
                                      : null}
                                  </span>
                                  {item?.attributes?.map((childItem, indx) => (
                                    <div
                                      key={childItem.id || indx}
                                      className=" mt-2"
                                    >
                                      <span className="fs-14 fw-semibold">
                                        {" "}
                                        {childItem?.value != null
                                          ? `Rs. ${(
                                              childItem?.value * count
                                            ).toFixed(2)}`
                                          : null}
                                      </span>
                                    </div>
                                  ))}
                                </>
                              )}
                            </div>

                            <div className="d-flex justify-content-between align-items-center align-content-center">
                              <div className="d-flex align-content-center align-items-center justify-content-center">
                                <h6 className="text-muted">
                                  {item?.productPrice !== null &&
                                  item?.productPrice !== undefined
                                    ? `Q/R: ${item.productPrice.toFixed(2)}`
                                    : null}
                                </h6>
                              </div>
                              <div className="d-flex gap-2 align-content-center align-items-center justify-content-center">
                                {orderData[selectedCourt?.TableKey]?.items &&
                                item.orderItemStatus !== "Ordered" ? (
                                  <button
                                    className="btn btn-sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleNote(item);
                                    }}
                                  >
                                    <i className="bx bx-notepad text-success fs-5"></i>
                                  </button>
                                ) : null}

                                {item.quantity > 0 && (
                                  <div className="d-flex gap-2 align-items-center justify-content-center align-content-center">
                                    <Button
                                      variant="outline"
                                      color="light"
                                      size="sm"
                                      className=""
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        updateQuantity(OrderIndex, count - 1);
                                      }}
                                    >
                                      −
                                    </Button>

                                    <input
                                      type="number"
                                      className="form-control form-control-sm text-center w-auto"
                                      value={count}
                                      min="1"
                                      max="100"
                                      style={{
                                        width: "40px",
                                        height: "28px",
                                        fontSize: "12px",
                                        padding: 0,
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={(e) =>
                                        updateQuantity(
                                          OrderIndex,
                                          Number(e.target.value)
                                        )
                                      }
                                    />

                                    <Button
                                      variant="outline"
                                      color="light"
                                      size="sm"
                                      className=""
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        updateQuantity(OrderIndex, count + 1);
                                      }}
                                    >
                                      +
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
              </>
            )}
          </div>

          <FoodCourt
            isOpen={isTableOpen}
            toggle={toggleTableModal}
            data={sectionData}
            setSelectedSection={setSelectedSection}
            selectedSection={selectedSection}
            loading={loading}
            handleRefresh={handleRefresh}
            isRefreshing={isRefreshing}
            selectedCourt={selectedCourt}
            setSelectedCourt={setSelectedCourt}
            fetchSection={fetchSection}
            fetchTable={fetchTable}
          />

          <CancelOrder
            show={deleteModal}
            onDeleteClick={handleDeleteItem}
            onCloseClick={toggleDeleteModal}
            setRemarks={setRemarks}
            remarks={remarks}
            setTouched={setTouched}
            touched={touched}
            isInvalid={isInvalid}
          />
          <NoteModal
            isOpen={isNoteOpen}
            toggle={() => setIsNoteOpen(false)}
            selectedNote={activeNoteProduct}
            productExtrasMap={productExtrasMap}
            onSubmit={(data) => {
              // Save note + extras for this product in the map
              setProductExtrasMap((prev) => ({
                ...prev,
                [data.productId]: data,
              }));

              // Add product to selectedNotes array if not already added
              setSelectedNotes((prev) => {
                if (!prev.find((p) => p.productId === data.productId)) {
                  return [...prev, { productId: data.productId }];
                }
                return prev;
              });
            }}
          />
        </div>
      </OffcanvasBody>

      <div
        className="p-3 border-top bg-white shadow-lg d-flex gap-2 d-flex flex-column"
        style={{ position: "sticky", bottom: 0, zIndex: 1060 }}
      >
        <div
          style={{
            border: "1px dashed #e0e0e0",
            backgroundColor: "#f8f9fa",
          }}
          className="p-2 rounded-4"
        >
          <div className="d-flex justify-content-between fw-bold fs-6 text-success">
            <span>Total</span>
            <span>Rs. {calculateTotals.total.toFixed(2)}</span>
          </div>
        </div>
        <div className="position-relative w-100">
          {selectedItems.length > 0 ? (
            <div className="transition-slide-left active ">
              <button
                onClick={toggleDeleteModal}
                className="btn btn-soft-danger  w-100 fw-semibold mb-2"
              >
                Cancel Selected Order ({selectedItems.length})
              </button>
            </div>
          ) : (
            <div className="transition-slide-left  ">
              {isQuantityChanged ? (
                <button
                  className="btn btn-warning fw-semibold w-100 mb-2"
                  onClick={handlePlaceOrder}
                >
                  Update Order
                </button>
              ) : (
                <button
                  className={`btn btn-${orderButtonState.variant} fw-semibold w-100 mb-2`}
                  onClick={orderButtonState.action}
                  disabled={orderButtonState.disabled}
                >
                  {orderButtonState.text}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </Offcanvas>
  );
};

export default OrderSummaryModal;
